import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../../components/ui/select";
import {
  PAYMENT_TRACKING_STATUS_OPTIONS,
  type PaymentTrackingStatus,
} from "./types";
import { paymentStatusDotClass } from "./utils";

interface PaymentStatusSelectProps {
  value: PaymentTrackingStatus;
  onValueChange: (value: PaymentTrackingStatus) => void;
  triggerClassName?: string;
  contentClassName?: string;
  disabled?: boolean;
}

const PaymentStatusSelect = ({
  value,
  onValueChange,
  triggerClassName = "h-7 w-32 px-2 text-xs",
  contentClassName = "bg-white",
  disabled = false,
}: PaymentStatusSelectProps) => (
  <Select
    value={value}
    onValueChange={nextValue =>
      onValueChange(nextValue as PaymentTrackingStatus)
    }
    disabled={disabled}
  >
    <SelectTrigger className={triggerClassName}>
      <span className="flex items-center gap-2 overflow-hidden">
        <span
          className={`h-1.5 w-1.5 shrink-0 rounded-full ${paymentStatusDotClass(value)}`}
        />
        <SelectValue />
      </span>
    </SelectTrigger>
    <SelectContent className={contentClassName}>
      {PAYMENT_TRACKING_STATUS_OPTIONS.map(status => (
        <SelectItem key={status} value={status} className="text-xs">
          <span className="flex items-center gap-2">
            <span
              className={`h-1.5 w-1.5 rounded-full ${paymentStatusDotClass(status)}`}
            />
            {status}
          </span>
        </SelectItem>
      ))}
    </SelectContent>
  </Select>
);

export default PaymentStatusSelect;
